// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"320":"5befade15f44dff5","669":"a91a5baf955b8855"}[chunkId] + ".js";
};